import UserConfig from "@//views/configs/user/index.vue";

export default [
  {
    path: "usuarios",
    name: "Config Usuarios",
    component: UserConfig,
  },
];
